import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse, UnlockUserType } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useUnlockIndependentIraUser = () => {
  const queryClient = useQueryClient();
  const mutate = async ({ id, isCancelAutoLock }: UnlockUserType) => {
    const { data } = await api.unlockIndependentIraUser(id, isCancelAutoLock);

    return data;
  };

  const mutationKey = MutationKeys.lockIndependentIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, UnlockUserType>(
    mutationKey,
    mutate,
    {
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries(QueryKeys.independentIraUsers);
        queryClient.invalidateQueries([QueryKeys.independentIraUser, id]);
      },
    },
  );
};
